export default __webpack_public_path__ + "c8fd54e9d9c443959425fc0c37111ddc.svg";